import { Locale } from "../schema/Locale.js";

const dateTimeMonthYearFormat: Record<Locale, Intl.DateTimeFormat> = {
	[Locale.cs]: new Intl.DateTimeFormat("cs-CZ", {
		year: "numeric",
		day: "numeric",
		month: "numeric",
		timeZone: "Europe/Prague",
		weekday: "long",
	}),
};

export function toWeekdayDateMonthYearFormat(date: number | Date | string, locale: Locale): string {
	return dateTimeMonthYearFormat[locale].format(typeof date === "string" ? new Date(date) : date);
}
